module.exports = {
  "/": {
    "success": [
      "TODO_THIS_ALWAYS_REDIRECTS_WE_NEED_A_WAY_TO_HANDLE_THIS"
    ],
    "error": [
      "ERROR_PAGE"
    ],
    "name": "rootView"
  },
  "/sales": {
    "success": [
      "SALES_PAGE"
    ],
    "error": [
      "FAILED_LOAD_BANNER",
      "ERROR_PAGE"
    ]
  },
  "/service": {
    "success": [
      "SERVICE_PAGE"
    ],
    "error": [
      "FAILED_LOAD_BANNER",
      "ERROR_PAGE"
    ]
  },
  "/marketing": {
    "success": [
      "MARKETING_PAGE"
    ],
    "error": [
      "FAILED_LOAD_BANNER",
      "ERROR_PAGE"
    ]
  },
  "/growth-suite": {
    "success": [
      "GROWTH_SUITE_PAGE"
    ],
    "error": [
      "FAILED_LOAD_BANNER",
      "ERROR_PAGE"
    ]
  },
  "/cms": {
    "success": [
      "CMS_PAGE"
    ],
    "error": [
      "FAILED_LOAD_BANNER",
      "ERROR_PAGE"
    ]
  },
  "/bundle": {
    "success": [
      "BUNDLE_PAGE"
    ],
    "error": [
      "FAILED_LOAD_BANNER",
      "ERROR_PAGE"
    ]
  },
  "/crm": {
    "success": [
      "FREE_TOOLS_PAGE"
    ],
    "error": [
      "ERROR_PAGE"
    ]
  },
  "/confirm-suite-contacts": {
    "success": [
      "SUITE_CONTACTS_PAGE"
    ],
    "error": [
      "ERROR_PAGE"
    ],
    "name": "confirmSuiteContactsView"
  },
  "/confirm-contacts": {
    "success": [
      "CONTACTS_CONFIRMATION_PAGE"
    ],
    "error": [
      "ERROR_PAGE"
    ],
    "name": "confirmContactsView"
  },
  "/legacy-confirmation": {
    "success": [
      "LEGACY_CONFIRMATION_PAGE"
    ],
    "error": [
      "ERROR_PAGE"
    ],
    "name": "legacyConfirmationView"
  }
};


//////////////////
// WEBPACK FOOTER
// ./rhumb-config.yaml
// module id = 558
// module chunks = 5 6